export default __webpack_public_path__ + "static/media/step3.f21dd6a6.svg";